// extracted by mini-css-extract-plugin
export default {"data_warning":"ojp6W9XXmaWV1t4RQuwBA","dataWarning":"ojp6W9XXmaWV1t4RQuwBA"};